import Cell from "../../../../model/form/cell";
import {CellItem} from "../../../../model/items/cellItem";
import {Questionary} from "../../../../model/questionary";
import m, {Vnode} from "mithril";
import {RadioItem} from "../../../../model/items/radio";
import h from "../../../../ui/design";
import {XmlTagInfo} from "../../../../model/xmlTagProvider";

export default class HubCell {

    private readonly radio!: RadioItem;
    private readonly questionary: Questionary;
    private readonly imageTag: XmlTagInfo|null;

    constructor(
        public readonly cell: Cell,
        private readonly setValue: ((cellItem: CellItem, value: any)=>void)|null = null
    ) {
        this.questionary = cell.grid.questionary;

        for (const item of cell.cellItems) {
            if (item instanceof RadioItem) {
                this.radio = item;
            }
        }

        if (!this.radio) {
            throw Error(`Expected radio in cell ${cell.id}. Radio missing.`);
        }

        const imageTags = this.radio.childrenTags.filter(tag => tag.tag === "image");
        this.imageTag = imageTags.length ? imageTags[0] : null;
    }

    private extractImageUrl(selected: boolean): string|null {
        let file = null;
        if (this.imageTag) {
            const imageAttributes = this.imageTag.attributes;
            file = (selected && imageAttributes.selected) ? imageAttributes.selected : imageAttributes.normal;
        }
        if (file !== null) {
            return this.questionary.getFileUrl(file);
        }
        return null;
    }

    public view(): Vnode|null {

        if (!this.cell.visible) {
            return null;
        }

        const enabled = this.cell.enabled;
        const checked = this.radio.isChecked();

        return m("label"+(checked?h.backgroundSelected:''), {}, [
            m("input",
                {
                    type: "radio",
                    name: this.radio.variableName,
                    value: this.radio.getValue(),
                    disabled: !enabled,
                    onclick: () => {
                        if (!enabled) {
                            return;
                        }
                        const value = this.radio.getValue();
                        if (this.setValue) {
                            this.setValue(this.radio, value);
                        } else {
                            this.radio.setVariable(value);
                        }
                    },
                    checked: checked,
                },
            ),
            m("span", {}, [
                this.imageTag ? m('img', {draggable: false, src: this.extractImageUrl(checked)}) : null,
                m('.label', m.trust(this.questionary.renderText(this.radio.childrenTags[0]?.value || ''))),
            ])
        ]);
    }

}